import ReportActionTypes from "./report.types";
const INITIAL_STATE = {
  currentReport: null,
  currentUserRating: null,
  items: [],
  loading: false,
  error: null,
};

const reportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ReportActionTypes.FETCH_REPORTS_START:
      return { ...state, loading: true };
    case ReportActionTypes.FETCH_REPORTS_SUCCESS:
      return { ...state, items: action.payload, loading: false, error: null };
    case ReportActionTypes.FETCH_REPORTS_FAILURE:
      return { ...state, items: null, error: action.payload, loading: false };
    case ReportActionTypes.SET_CURRENT_REPORT:
      return { ...state, currentReport: action.payload };
    case ReportActionTypes.SAVE_REPORT_START:
      return { ...state, loading: true };
    case ReportActionTypes.SAVE_REPORT_SUCCESS:
      return { ...state, loading: false, currentReport: action.payload };
    case ReportActionTypes.SAVE_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case ReportActionTypes.ADD_REPORT:
      return { ...state, items: state.items.concat([action.payload]) };
    case ReportActionTypes.SET_CURRENT_REPORT_BY_ID:
      return {
        ...state,
        currentReport: state.items.find((r) => r.id === action.payload),
      };
    case ReportActionTypes.RATE_REPORT_FAILURE:
      return { ...state, error: action.payload };
    case ReportActionTypes.RATE_REPORT_SUCCESS:
    case ReportActionTypes.GET_USER_RATING_SUCCESS:
      return { ...state, currentUserRating: action.payload };
    default:
      return state;
  }
};

export default reportReducer;
